import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Button from '@salesforce/design-system-react/components/button';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface CaseId {
  id: string;
  caseExternalId: string;
  caseNumber: string;
}

// interface for props that the data table cell is getting default from data table.
export interface Props extends RouteComponentProps {
  children?: FC;
  item?: CaseId;
  type?: string;
}

const ExpenseInventoryIdCell: FC<Props> = ({
  item = {
    id: null,
    caseExternalId: null,
    caseNumber: null,
  },
  history,
  type = null,
}) => {
  const { caseExternalId, caseNumber } = item;
  const goToExpenseInventoryDetails = (): void => {
    history.push('/inventoryExpenseDetails', {
      externalId: caseExternalId,
      caseNumber,
      type,
    });
  };
  return (
    <DataTableCell title={caseNumber || ''}>
      <Button variant="base" onClick={goToExpenseInventoryDetails}>
        {caseNumber}
      </Button>
    </DataTableCell>
  );
};

export default withRouter(ExpenseInventoryIdCell);
